import { useState } from 'react';

export const globalTabState = {
  activeTabTitle: null,
};

export const useActiveTab = () => {
  const [activeTabTitle, setActiveTabTitle] = useState<string | null>(globalTabState.activeTabTitle);

  const setActiveTab = (title: string) => {
    if (title === activeTabTitle) return;
    globalTabState.activeTabTitle = title;
    setActiveTabTitle(title);
  };

  return { activeTabTitle, setActiveTab };
};
